import React from 'react';
import { ExchangeRateDateEnum } from '../../../../app/shared/enums';
import { DispatchProgramInvoicingShowDataForm } from '../../../../app/models/DispatchProgramInvoicing';

interface Props {
  dispatchProgramInvoicingDataForm: DispatchProgramInvoicingShowDataForm;
  setDispatchProgramInvoicingDataForm: (dispatch: DispatchProgramInvoicingShowDataForm) => void;
  errorFields?: Record<string, unknown>;
  isShow?: boolean;
}

const DispatchProgramInvoicingShowForm: React.FC<Props> = ({
  dispatchProgramInvoicingDataForm,
  setDispatchProgramInvoicingDataForm: _setDispatchProgramInvoicingDataForm,
  errorFields: _errorFields,
  isShow = false,
}) => {
  const showPrelimFixed =
    dispatchProgramInvoicingDataForm.preliminary_exchange_rate_date_reference?.id ===
    ExchangeRateDateEnum.FECHA_FIJA;

  const showFinalFixed =
    dispatchProgramInvoicingDataForm.final_exchange_rate_date_reference?.id ===
    ExchangeRateDateEnum.FECHA_FIJA;

  void _setDispatchProgramInvoicingDataForm;
  void _errorFields;
  void isShow;

  const standardWeightEnabled = !!dispatchProgramInvoicingDataForm.use_standard_weight;
  const standardWeightDisplay = standardWeightEnabled && dispatchProgramInvoicingDataForm.standard_weight_value !== null && dispatchProgramInvoicingDataForm.standard_weight_value !== undefined
    ? `${String(dispatchProgramInvoicingDataForm.standard_weight_value)}${dispatchProgramInvoicingDataForm.standard_weight_unit_name ? ` ${dispatchProgramInvoicingDataForm.standard_weight_unit_name}` : ''}`
    : 'No aplica';

  const standardWeightLowerLimitDisplay = standardWeightEnabled && dispatchProgramInvoicingDataForm.standard_weight_lower_limit !== null && dispatchProgramInvoicingDataForm.standard_weight_lower_limit !== undefined
    ? `${String(dispatchProgramInvoicingDataForm.standard_weight_lower_limit)}${dispatchProgramInvoicingDataForm.standard_weight_lower_limit_unit_name ? ` ${dispatchProgramInvoicingDataForm.standard_weight_lower_limit_unit_name}` : ''}`
    : 'No aplica';

  return (
    <div className="container-fluid">
      {/* Forma de pago, condición de pago, moneda y fuente TC: heredados del pedido, no editables aquí */}
      <div className="row mb-3">
        <div className="col-md-6">
          <label>Forma de Pago</label>
          <input
            type="text"
            className="form-control bg-light"
            value={dispatchProgramInvoicingDataForm.payment_method || ''}
            readOnly
          />
        </div>
        <div className="col-md-6">
          <label>Condición de Pago</label>
          <div className="row g-1">
            <div className="col-8">
              <input
                type="text"
                className="form-control bg-light"
                value={dispatchProgramInvoicingDataForm.reference || ''}
                readOnly
                placeholder="Referencia"
              />
            </div>
            <div className="col-4">
              <input
                type="number"
                className="form-control bg-light"
                value={dispatchProgramInvoicingDataForm.days_count ?? ''}
                readOnly
                placeholder="Días"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-md-6">
          <label>Moneda</label>
          <input
            type="text"
            className="form-control bg-light"
            value={dispatchProgramInvoicingDataForm.currency || ''}
            readOnly
          />
        </div>
        <div className="col-md-6">
          <label>Fuente Tipo de Cambio</label>
          <input
            type="text"
            className="form-control bg-light"
            value={dispatchProgramInvoicingDataForm.exchange_rate_date_source || ''}
            readOnly
          />
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-md-6">
          <label className="form-label">Peso padrón</label>
          <input type="text" className="form-control bg-light" value={standardWeightDisplay} readOnly />
        </div>
        <div className="col-md-6">
          <label className="form-label">Límite inferior</label>
          <input type="text" className="form-control bg-light" value={standardWeightLowerLimitDisplay} readOnly />
        </div>
      </div>

      {/* Tipo de cambio preliminar y final */}
      <div className="row">
        {/* — Preliminar — */}
        <div className="col-lg-6 mb-3">
          <label>Tipo de Cambio Prov</label>
          <input
            type="text"
            className="form-control bg-light"
            value={dispatchProgramInvoicingDataForm.preliminary_exchange_rate_date_reference_value || ''}
            readOnly
          />

          {!showPrelimFixed && (
            <div className="row g-2 mt-2">
              <div className="col-3">
                <label className="form-label">Días (Prov)</label>
                <input
                  type="number"
                  className="form-control bg-light"
                  value={dispatchProgramInvoicingDataForm.preliminary_days ?? ''}
                  readOnly
                />
              </div>
              <div className="col-3">
                <label className="form-label">Meses (Prov)</label>
                <input
                  type="number"
                  className="form-control bg-light"
                  value={dispatchProgramInvoicingDataForm.preliminary_months ?? ''}
                  readOnly
                />
              </div>
              <div className="col-3">
                <label className="form-label">Año (Prov)</label>
                <input
                  type="number"
                  className="form-control bg-light"
                  value={dispatchProgramInvoicingDataForm.preliminary_year ?? ''}
                  readOnly
                />
              </div>
            </div>
          )}

          <div className="row g-2 mt-2">
            <div className="col-6">
              <label className="form-label">
                {showPrelimFixed ? 'Fecha Fija (Prov)' : 'Fecha Ref. Tipo Cambio (Prov)'}
              </label>
              <input
                type="date"
                className="form-control bg-light"
                value={
                  showPrelimFixed
                    ? dispatchProgramInvoicingDataForm.preliminary_fixed_date || ''
                    : dispatchProgramInvoicingDataForm.preliminary_exchange_rate_date || ''
                }
                readOnly
              />
            </div>
            <div className="col-6">
              <label className="form-label">Valor Tipo Cambio (Prov)</label>
              <input
                type="text"
                className="form-control bg-light"
                value={
                  dispatchProgramInvoicingDataForm.prelim_rate !== undefined &&
                  dispatchProgramInvoicingDataForm.prelim_rate !== null
                    ? dispatchProgramInvoicingDataForm.prelim_rate
                    : ''
                }
                readOnly
              />
            </div>
          </div>
        </div>

        {/* — Final — */}
        <div className="col-lg-6 mb-3">
          <label>Tipo de Cambio Final</label>
          <input
            type="text"
            className="form-control bg-light"
            value={dispatchProgramInvoicingDataForm.final_exchange_rate_date_reference_value || ''}
            readOnly
          />

          {!showFinalFixed && (
            <div className="row g-2 mt-2">
              <div className="col-3">
                <label className="form-label">Días (Final)</label>
                <input
                  type="number"
                  className="form-control bg-light"
                  value={dispatchProgramInvoicingDataForm.final_days ?? ''}
                  readOnly
                />
              </div>
              <div className="col-3">
                <label className="form-label">Meses (Final)</label>
                <input
                  type="number"
                  className="form-control bg-light"
                  value={dispatchProgramInvoicingDataForm.final_months ?? ''}
                  readOnly
                />
              </div>
              <div className="col-3">
                <label className="form-label">Año (Final)</label>
                <input
                  type="number"
                  className="form-control bg-light"
                  value={dispatchProgramInvoicingDataForm.final_year ?? ''}
                  readOnly
                />
              </div>
            </div>
          )}

          <div className="row g-2 mt-2">
            <div className="col-6">
              <label className="form-label">
                {showFinalFixed ? 'Fecha Fija (Final)' : 'Fecha Ref. Tipo Cambio (Final)'}
              </label>
              <input
                type="date"
                className="form-control bg-light"
                value={
                  showFinalFixed
                    ? dispatchProgramInvoicingDataForm.final_fixed_date || ''
                    : dispatchProgramInvoicingDataForm.final_exchange_rate_date || ''
                }
                readOnly
              />
            </div>
            <div className="col-6">
              <label className="form-label">Valor Tipo Cambio (Final)</label>
              <input
                type="text"
                className="form-control bg-light"
                value={
                  dispatchProgramInvoicingDataForm.final_rate !== undefined &&
                  dispatchProgramInvoicingDataForm.final_rate !== null
                    ? dispatchProgramInvoicingDataForm.final_rate
                    : ''
                }
                readOnly
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DispatchProgramInvoicingShowForm;
